(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sevenfold-sales-letter"] && !Shopify.designMode) return;
  try {
    
(() => {
  function mountIllustrations(root) {
    const dialog = root.querySelector('[data-sf-visual-dialog]');
    if (!dialog || dialog.dataset.sfMounted || typeof dialog.showModal !== 'function') return;
    dialog.dataset.sfMounted = 'true';
    const image = dialog.querySelector('[data-sf-full-image]');
    const title = dialog.querySelector('[data-sf-visual-title]');
    const zoom = dialog.querySelector('[data-sf-visual-zoom]');
    const viewport = dialog.querySelector('[data-sf-visual-viewport]');
    let trigger;
    let previousOverflow = '';
    function fitViewport() {
      if (!dialog.open) return;
      const header = dialog.querySelector('.sf-visual-dialog-header');
      const available = Math.max(0, window.innerHeight * 0.94 - header.getBoundingClientRect().height - 2);
      const preferred = window.innerHeight * (window.matchMedia('(max-width: 650px)').matches ? 0.68 : 0.76);
      dialog.style.setProperty('--sf-visual-fit-height', Math.floor(Math.min(available, preferred)) + 'px');
    }
    function resetZoom() {
      viewport.classList.remove('sf-is-zoomed');
      viewport.scrollTo(0, 0);
      zoom.setAttribute('aria-pressed', 'false');
      zoom.textContent = zoom.dataset.zoomLabel;
    }
    root.querySelectorAll('[data-sf-zoom]').forEach(link => {
      link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        trigger = link;
        const illustration = link.closest('figure').querySelector('img');
        title.textContent = link.dataset.sfTitle;
        image.src = link.href;
        image.alt = illustration.alt;
        image.width = Number(illustration.dataset.sfFullWidth || illustration.width);
        image.height = Number(illustration.dataset.sfFullHeight || illustration.height);
        resetZoom();
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
        fitViewport();
      });
    });
    window.addEventListener('resize', fitViewport);
    zoom.addEventListener('click', () => {
      const isZoomed = viewport.classList.toggle('sf-is-zoomed');
      zoom.setAttribute('aria-pressed', String(isZoomed));
      zoom.textContent = isZoomed ? zoom.dataset.fitLabel : zoom.dataset.zoomLabel;
      viewport.scrollTo(0, 0);
    });
    dialog.querySelector('[data-sf-visual-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      resetZoom();
      image.removeAttribute('src');
      if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
    });
  }
  document.querySelectorAll('.sf-letter').forEach(mountIllustrations);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.sf-letter').forEach(mountIllustrations));
})();

(() => {
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const popup = root.querySelector('[data-sf-jump-prompt]');
    const trigger = root.querySelector('[data-sf-jump-trigger]');
    const target = root.querySelector('[data-sf-jump-target]');
    const status = root.querySelector('[data-sf-jump-status]');
    if (!popup || !trigger || !target || !status) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const nativePopover = typeof popup.showPopover === 'function';
    const frequency = popup.dataset.sfJumpFrequency || 'session';
    const storageKey = 'sevenfold:jump-prompt:v1:' + location.pathname;
    const title = popup.querySelector('[data-sf-jump-title]').textContent.trim();
    let consumed = false;
    let reachedTarget = false;
    let userScrolled = false;
    let frame = 0;
    let previousFocus;
    let lastScroll = window.scrollY;
    try {
      if (frequency === 'session') consumed = sessionStorage.getItem(storageKey) === 'seen';
      if (frequency === 'day') {
        const seenAt = Number(localStorage.getItem(storageKey));
        consumed = seenAt > 0 && Date.now() - seenAt < 86400000;
      }
    } catch {}
    if (!nativePopover) {
      popup.removeAttribute('popover');
      const styles = getComputedStyle(root);
      ['--sf-ink', '--sf-background', '--sf-gold', '--sf-surface'].forEach(name => popup.style.setProperty(name, styles.getPropertyValue(name)));
      document.body.appendChild(popup);
    }
    function remember() {
      consumed = true;
      try {
        if (frequency === 'session') sessionStorage.setItem(storageKey, 'seen');
        if (frequency === 'day') localStorage.setItem(storageKey, String(Date.now()));
      } catch {}
    }
    function hide(restoreFocus = true) {
      if (popup.hidden) return;
      const hadFocus = popup.contains(document.activeElement);
      if (nativePopover && popup.matches(':popover-open')) popup.hidePopover();
      popup.hidden = true;
      popup.removeAttribute('data-sf-jump-visible');
      status.textContent = '';
      if (restoreFocus && hadFocus) {
        const focus = previousFocus && previousFocus.isConnected && previousFocus !== document.body ? previousFocus : trigger;
        focus.focus({ preventScroll: true });
      }
    }
    function show(force = false) {
      if (!popup.hidden || (consumed && !force)) return;
      if (!force && popup.dataset.sfJumpMobile === 'false' && matchMedia('(max-width: 650px)').matches) return;
      if (document.hidden || document.querySelector('dialog[open]')) return;
      const active = document.activeElement;
      if (active && (active.matches('input, textarea, select') || active.isContentEditable)) return;
      previousFocus = active;
      popup.hidden = false;
      if (nativePopover) {
        try { popup.showPopover({ source: trigger }); }
        catch { popup.hidden = true; return; }
      }
      popup.setAttribute('data-sf-jump-visible', '');
      remember();
      status.textContent = title;
    }
    function check() {
      frame = 0;
      const currentScroll = window.scrollY;
      if (currentScroll !== lastScroll) userScrolled = true;
      lastScroll = currentScroll;
      if (consumed && popup.hidden) return;
      if (target.getBoundingClientRect().top <= window.innerHeight) {
        reachedTarget = true;
        const hadFocus = popup.contains(document.activeElement);
        hide(false);
        if (hadFocus) target.focus({ preventScroll: true });
        return;
      }
      if (!userScrolled || reachedTarget || trigger.getBoundingClientRect().bottom > 0) return;
      show();
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(check); }
    popup.querySelectorAll('[data-sf-jump-dismiss]').forEach(button => button.addEventListener('click', () => hide(), options));
    popup.querySelector('[data-sf-jump-go]').addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const hash = event.currentTarget.hash;
      hide(false);
      reachedTarget = true;
      target.focus({ preventScroll: true });
      try { history.replaceState(history.state, '', hash); } catch {}
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    }, options);
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || popup.hidden || document.querySelector('dialog[open]')) return;
      event.preventDefault();
      hide();
    }, options);
    root.addEventListener('click', event => {
      if (event.target.closest('[data-sf-zoom], .sf-cta')) hide(false);
    }, options);
    root.addEventListener('sf:jump-preview', () => show(true), options);
    root.addEventListener('focusout', schedule, options);
    window.addEventListener('scroll', schedule, { passive: true, signal: controller.signal });
    window.addEventListener('resize', schedule, { passive: true, signal: controller.signal });
    document.addEventListener('visibilitychange', schedule, options);
    instances.set(root, () => {
      hide(false);
      controller.abort();
      cancelAnimationFrame(frame);
      if (!nativePopover) popup.remove();
      instances.delete(root);
    });
    check();
  }
  document.querySelectorAll('.sf-letter').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.sf-letter').forEach(mount));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, root) => { if (event.target.contains(root)) cleanup(); });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-framework-header"] && !Shopify.designMode) return;
  try {
    
const previewHeader = document.querySelector('[data-sfv-preview]');
if (previewHeader && previewHeader.dataset.sfvPreview) {
 const previewURL = new URL(window.location.href);
 if (!previewURL.searchParams.has('preview_theme_id')) {
  previewURL.searchParams.set('preview_theme_id', previewHeader.dataset.sfvPreview);
  window.history.replaceState(window.history.state, '', previewURL.href);
 }
}

document.addEventListener('click', function(event) {
 const link = event.target.closest('.sfv-mobile-nav a');
 if (link) link.closest('details').removeAttribute('open');
});

  } catch(e) { console.error(e); }
})();
})();
